export class PatchUpdateRequest {
    constructor(
        public propertyName: string,
        public updatedValue: any,
    ) { }
}
